import React from 'react'
import { bool } from 'prop-types'
import MdDirectionsRun from 'react-icons/lib/md/directions-run'
import styles from './Loading.styl'

class Loading extends React.Component {

	static propTypes = {
		noBackground: bool
	}

	render() {
		const { noBackground } = this.props
		return (
			<main className={ `${ styles['main'] } ${ noBackground ? styles['no-background'] : '' }` }>
				<div className={ styles['icons'] }>
					<MdDirectionsRun className={ styles['one'] } />
					<MdDirectionsRun className={ styles['two'] } />
					<MdDirectionsRun className={ styles['three'] } />
				</div>
			</main>
		)
	}
}

export default Loading



// WEBPACK FOOTER //
// ./src/client/webapp/components/Loading/Loading.js